import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICommunity } from "../communityModel";

export const getAllCommunities = createAsyncThunk(
  "Community/FindAllCommunity",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Community/FindAllCommunity`,
        {
          PersonName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Communities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCommunity = createAsyncThunk(
  "Community/InsertCommunity",
  async (CommunityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Community/InsertCommunity`,
        CommunityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating community:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCommunity = createAsyncThunk(
  "Community/UpdateCommunity",
  async (CommunityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Community/UpdateCommunity`,
        CommunityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating community :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCommunity = createAsyncThunk(
  "Community/DeleteCommunity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Community/DeleteCommunity`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting community :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCommunityByID = createAsyncThunk(
  "Community/FindByIDCommunity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Community/FindByIDCommunity`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PersonName: result?.PersonName,
        TourID: result?.TourID,
        Title: result?.Title,
        InstaProfile: result?.InstaProfile,
        LongDescription: result?.LongDescription || "",
        ShortDescription: result?.ShortDescription || "",
        TotalSeats: result?.TotalSeats,
        GroupSize: result?.GroupSize,
        Description: result?.Description || "",
        FacebookProfile: result?.FacebookProfile,
        LinkedInProfile: result?.LinkedInProfile,
        TwitterProfile: result?.TwitterProfile,
        WebsiteProfile: result?.WebsiteProfile,
        PersonImage: result?.PersonImage,
        CommunityImage: result?.CommunityImage,
        Date: result?.Date,
        ActivityIDs: result?.ActivityIDs
          ? result?.ActivityIDs?.split(",")?.map((a: any) => +a)
          : [],
        IsActive: result.IsActive ? 1 : 2,
      } as ICommunity;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching community :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCommunities = createAsyncThunk(
  "Community/FindAllActiveCommunity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Community/FindAllActiveCommunity`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Communities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveCommunity = createAsyncThunk(
  "Community/ActiveInActiveCommunity",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Community/ActiveInActiveCommunity`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive community :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const CommunityImageUpload = createAsyncThunk(
  "Community/UpdateCommunityImage",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Community/UpdateCommunityImage`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Community Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
